import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = admin
  const [error, setError] = useState("");

  useEffect(() => {
    // Only probe the session on admin routes — avoids unnecessary 401s on public pages.
    if (typeof window !== "undefined" && window.location.pathname.startsWith("/admin")) {
      api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
    } else {
      setUser(false);
    }
  }, []);

  const login = async (email, password) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      return true;
    } catch (e) {
      setError(e.response?.data?.detail || "Unable to sign in.");
      return false;
    }
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, error }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
